import priceFormatter from 'data/services/price/formatter';
import {
    PriceTableContainer,
    Table,
    TableCell,
    TableRow,
} from './styled';

interface Props {
    total: number;
    surcharge?: number | null;
    currency: string;
}

const BillBreakdownTable = ({
    total,
    surcharge,
    currency,
}: Props) => {
    const amountCents = total - (surcharge ?? 0);
    const formatter = priceFormatter(currency);

    return (
        <PriceTableContainer>
            <Table>
                <tbody>
                    <TableRow>
                        <TableCell>Service Amount</TableCell>
                        <TableCell>{formatter.format(amountCents / 100)}</TableCell>
                    </TableRow>
                    {typeof surcharge === 'number' && (
                        <TableRow>
                            <TableCell>Service Fee</TableCell>
                            <TableCell>{formatter.format(surcharge / 100)}</TableCell>
                        </TableRow>
                    )}
                </tbody>
            </Table>
        </PriceTableContainer>
    );
};

export default BillBreakdownTable;
